var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "cb4x-content" } },
    [
      _c("h4", [_vm._v(_vm._s(_vm.headerBlock.title))]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("ob1-capsule", {
            attrs: { "is-information": true, label: _vm.headerBlock.feesLabel },
          }),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.headerBlock.subTitle))]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row-flex" },
        [
          _vm.paymentExampleBlock
            ? _c("p", { staticClass: "lead mb-0" }, [
                _c("strong", [_vm._v(_vm._s(_vm.paymentExampleBlock.title))]),
              ])
            : _c("p", { staticClass: "lead mb-0" }, [
                _c("strong", [_vm._v(_vm._s(_vm.paymentBlock.title))]),
              ]),
          _vm._v(" "),
          _vm.paymentExampleBlock
            ? _c("div", {
                staticClass: "lead",
                domProps: {
                  innerHTML: _vm._s(_vm.paymentExampleBlock.subTitle),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-between" }, [
            _c("div", { staticClass: "col-3 col-md-2" }, [
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.paymentSimulationBlock.text2) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-9 col-md-10" }, [
              _c("p", { staticClass: "mb-0" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.formatNumberToString(_vm.oneShotPrice)) + " €"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.paymentSimulationBlock.text3) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("ob1-separateur", {
            staticClass: "my-1",
            attrs: { color: "gray1" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-between" }, [
            _c("div", { staticClass: "col-3 col-md-2" }, [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.paymentSimulationBlock.text5),
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex col-9 col-md-10 justify-content-between" },
              [
                _c("div", { staticClass: "row w-100" }, [
                  _c("div", { staticClass: "col-10 col-md-5" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumberToString(_vm.firstMonthlyPrice)
                          ) + " €"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.paymentSimulationBlock.text4) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col col-md-5" }, [
                    _c("div", [
                      _c("p", { staticClass: "mb-0" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.formatNumberToString(_vm.monthlyPrice)) +
                              " €/mois"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.paymentSimulationBlock.text9) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "justify-content-between d-flex w-100" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "col-9 col-md-10" }, [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.paymentSimulationBlock.text6) +
                      "\n                        "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.formatNumberToString(_vm.oneShotPrice)) + " €"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.paymentSimulationBlock.text7) +
                      "\n                        "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.paymentSimulationBlock.text8) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.illustration
        ? _c(
            "div",
            { staticClass: "row pt-2 pb-1" },
            [
              _c("ob1-picture", {
                staticClass: "illustration",
                attrs: {
                  visual: _vm.illustration,
                  "css-classes": "d-block mx-auto",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.howToBenefit
        ? _c(
            "div",
            { staticClass: "bg-gray2 px-2 pb-1 mb-1 mb-md-2" },
            [
              _c("p", { staticClass: "mb-0" }, [
                _c("span", { staticClass: "lead" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.howToBenefit.title))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v(_vm._s(_vm.howToBenefit.subTitle))]),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.howToBenefit.texts,
                function (howToBenefitText, index) {
                  return _c(
                    "p",
                    {
                      key: "how-to-" + index,
                      staticClass: "d-flex align-items-center mb-0",
                    },
                    [
                      _c("span", {
                        staticClass: "font-size-24",
                        class: "icon-number-" + _vm.getIndex(index) + "-wired",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ms-1",
                        domProps: { innerHTML: _vm._s(howToBenefitText) },
                      }),
                    ]
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.faq
        ? _c("section", [
            _c("h4", {
              staticClass: "my-2",
              domProps: { innerHTML: _vm._s(_vm.faq.title) },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion mb-1",
                attrs: { id: "cb4x-content-faq" },
              },
              _vm._l(_vm.faq.textsBlock, function (textBlock, index) {
                return _c(
                  "div",
                  { key: "cb4x-content-faq-" + index },
                  [
                    _c(
                      "ob1-expanding-accordion-card",
                      {
                        ref: "cb4x-content-faq-link" + index,
                        refInFor: true,
                        attrs: {
                          "collapsed-block-id": "cb4x-content-faq" + index,
                          "link-id": "cb4x-content-faq-link" + index,
                          "link-title": textBlock.subTitle,
                          "is-card-body-max-width": true,
                          "data-oevent-category": _vm.faq.tms.tagZone,
                          "data-oevent-action": _vm.getFaqTagName(
                            textBlock.subTitle
                          ),
                          "data-oevent-label": _vm.getFaqTagTarget(
                            _vm.faq.tms.tagTarget,
                            textBlock.subTitle
                          ),
                        },
                      },
                      [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(textBlock.text) },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ob1-liens-haut-bas",
        {
          attrs: {
            "is-collapsed": false,
            "collapsed-block-id": "legal-mentions-4xcb-block",
            "button-label": _vm.cgu.title,
            "button-id": "legal-mentions-4xcb-link",
          },
        },
        [_c("p", { domProps: { innerHTML: _vm._s(_vm.cgu.text) } })]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-2" }, [
      _c("p", { staticClass: "mb-0" }, [_c("strong", [_vm._v("+")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3 col-md-2" }, [_c("p")])
  },
]
render._withStripped = true

export { render, staticRenderFns }